import { render } from "./RegistrationLandingPage.vue?vue&type=template&id=7a94d572"
import script from "./RegistrationLandingPage.vue?vue&type=script&lang=js"
export * from "./RegistrationLandingPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__